/**
 * Created by vladislav on 22.03.2021
 */

const CoinSlotMachineSymbol = function (reel, data, index) {
    cleverapps.EventEmitter.call(this);

    Object.assign(this, data);

    this.reel = reel;

    this.index = index;
};

CoinSlotMachineSymbol.prototype = Object.create(cleverapps.EventEmitter.prototype);
CoinSlotMachineSymbol.prototype.constructor = CoinSlotMachineSymbol;

CoinSlotMachineSymbol.prototype.animate = function (highlight) {
    this.trigger("animate", highlight);
};

CoinSlotMachineSymbol.prototype.reset = function () {
    this.trigger("reset");
};

CoinSlotMachineSymbol.prototype.move = function () {
    this.trigger("move");
};

CoinSlotMachineSymbol.prototype.spin = function (duration, isFast, isLast) {
    this.trigger("spin", duration, isFast, isLast);
};